import { BaseService } from './BaseService';
import { AnimalPhotoDownloadUrl, AnimalPhotoPage } from '../models/animal-photos';

/**
 * The committed photos of an animal and their read links. Called through `BaseService` because the
 * endpoints are newer than `src/api/HealthSystemApi.ts`; swap to the generated client once it is
 * regenerated. The list carries no image links: each photo's link is issued separately, is valid for
 * an hour, and must never be stored.
 */
export class AnimalPhotosService extends BaseService {
  /** `page` counts from 0, as the UI does; the API counts from 1. */
  getPhotos = async (animalId: string, page: number, size: number): Promise<AnimalPhotoPage> => {
    const query = this.BuildQueryString({ pageIndex: page + 1, pageSize: size });
    const result = await this.Fetch(`/animals/${animalId}/photos?${query}`, 'GET');
    return this.FromResult<AnimalPhotoPage>(result);
  };

  /** How many committed photos the animal has, without fetching any of them. */
  getPhotoCount = async (animalId: string): Promise<number> => {
    const page = await this.getPhotos(animalId, 0, 1);
    return page.totalCount ?? 0;
  };

  getDownloadUrl = async (animalId: string, photoId: string): Promise<AnimalPhotoDownloadUrl> => {
    const result = await this.Fetch(`/animals/${animalId}/photos/${photoId}/download-url`, 'GET');
    return this.FromResult<AnimalPhotoDownloadUrl>(result);
  };
}

export default AnimalPhotosService;
